// extracted by mini-css-extract-plugin
module.exports = {"divided":"two-column-cards_divided__mlvXK","cardItem":"two-column-cards_cardItem__V2ynA","column":"two-column-cards_column__Bj9Rt"};